/* raw layout hash: _work-order-packaging-dispatch-board-layout:a99e1b88d280dd798c2e179936be31db968c71508c7d11ec1affbd855efed31e */
import React from 'react';
import AppShell from './AppShell.jsx';
import { LAYOUT_MENUS } from './layoutMenus.js';

// Layout "_work-order-packaging-dispatch-board-layout" — renders its page content through the router outlet.
export default function WorkOrderPackagingDispatchBoardLayout() {
  return <AppShell layoutName="_work-order-packaging-dispatch-board-layout" menu={LAYOUT_MENUS['_work-order-packaging-dispatch-board-layout']} />;
}
